import React, {useEffect, useState} from 'react';
import {Alert, Col, Row} from 'antd';
import {useParams} from 'react-router-dom';
import SponsorPerksListing from '../../CommonComponents/SponsorListing/SponsorPerksListing';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import useLocalization from '../../../Localization';
import NavigationComponent from '../../CommonComponents/CommonBackButton';
import WaitingList from '../AddAttendees/WaitingList';
import './style.css';

const SponsorshipOptionComponent = ({
  allEventOptionsRegistrationData,
  getEventSponsorOptions,
  removeSponsorShipFromCart,
  eventLocalChapterData,
  eventName,
  waitingListData,
}) => {
  const {id} = useParams();
  const [sponsorshipOption, setSponsorOptionData] = useState([]);
  const {ApplicationString} = useLocalization();

  useEffect(() => {
    if (allEventOptionsRegistrationData) {
      setSponsorOptionData(allEventOptionsRegistrationData);
    }
  }, [allEventOptionsRegistrationData]);

  useEffect(() => {
    if (id) {
      getEventSponsorOptions(id);
    }
  }, [id]);

  const removeSponsorShipFromCartByEventId = () => {
    removeSponsorShipFromCart(id);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);
  return (
    <>
      <Row gutter={[0, 10]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={eventName}
            subTitle={
              ApplicationString['userSponsorshipOptionComponent.heading']
            }
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div className='hero-subheading'>
              {
                ApplicationString[
                  'sponsorshipOptionComponent.sponsorPerksListing.contactUs'
                ]
              }{' '}
              <a href='mailto:info@pbss.org'>
                {
                  ApplicationString[
                    'sponsorshipOptionComponent.sponsorPerksListing.contactUs.link'
                  ]
                }
              </a>{' '}
              {
                ApplicationString[
                  'sponsorshipOptionComponent.sponsorPerksListing.contactUs.description'
                ]
              }
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <NavigationComponent
              name={
                ApplicationString[
                  'sponsorshipOptionComponent.goBackToAttendeeRegistration'
                ]
              }
              urlPath={`addAttendees/${id}`}
            />
          </SectionLayout>
        </Col>
        <Col span={24}>
          {sponsorshipOption?.length > 0 ? (
            <SponsorPerksListing
              sponsorPerksData={sponsorshipOption}
              removeSponsorShipFromCartByEventId={
                removeSponsorShipFromCartByEventId
              }
              eventLocalChapterData={eventLocalChapterData}
            />
          ) : (
            <SectionLayout>
              <Alert
                message={
                  ApplicationString['userSponsorshipOption.alertMessage']
                }
                className='no-event-sponsor-alert'
                type='info'
                showIcon
              />
            </SectionLayout>
          )}
        </Col>
        {waitingListData?.length > 0 && (
          <Col span={24}>
            <SectionLayout>
              <WaitingList data={waitingListData} showSponsorshipType />
            </SectionLayout>
          </Col>
        )}
        {/* <Col span={24}>
          <SectionLayout>
            <CustomCollapse />
          </SectionLayout>
        </Col> */}
      </Row>
    </>
  );
};

export default SponsorshipOptionComponent;
